export enum AddonTypeEnum {
  TV = 'TV',
  PRIME = 'PRIME',
}
